import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router';
import { Context } from '../../../store/Store.js';
import { ForgeListItem } from '@tylertech/forge-react';
import ConditionalTooltip from '../../reusable/ConditionalTooltip.js';
import { renderIcon } from './navHelper.js';
import { REDUCER_ACTION_TYPES } from '../../../store/Reducer.js';
import { useUser } from '../../../contexts/userContext.js';
import { buildPath } from '../../../services/navigateService.js';
import { NO_BUDGET } from '../../../static/constants.js';

const NavItem = ({ itemName, iconName, to, setSelected, selected }) => {
  const [state, dispatch] = useContext(Context);
  const navigate = useNavigate();
  const buttonRef = React.useRef(null);
  const { user } = useUser();

  const getLocation = () => {
    const orgId = user?.activeOrganization;
    const budgetId = user?.activeBudget?.id || NO_BUDGET;

    if (!orgId || !budgetId) return;
    const path = state.fireUnsavedChangesDialog || state.changesWereMade ? null : buildPath(user, to);

    dispatch({ type: REDUCER_ACTION_TYPES.SET_USER_NAVIGATED, payload: !state.userNavigated });
    setSelected(itemName);
    navigate(path);
  };
  return (
    <ForgeListItem
      key={itemName}
      selected={selected}
      id={`${itemName.replaceAll(' ', '-')}-nav-item`}
      className="clickable"
      on-forge-list-item-select={getLocation}
    >
      {renderIcon(iconName, selected)}
      <button ref={buttonRef}>{itemName}</button>
      <ConditionalTooltip
        name={itemName}
        targetRef={buttonRef}
      />
    </ForgeListItem>
  );
};

NavItem.propTypes = {
  itemName: PropTypes.string,
  iconName: PropTypes.string,
  to: PropTypes.string,
  setSelected: PropTypes.func,
  selected: PropTypes.bool,
};

export default NavItem;
